<template>
  <div>
    <div class="content-header">
      <div class="left">个人中心</div>
      <div class="right"></div>
      <div class="bottom"></div>
    </div>
    <div class="from">
      <div class="item" style="height: 40px">
        <div class="title" style="line-height: 60px">头像：</div>
        <div class="content">
          <div class="avatarBox">
            <img :src="current_user.avatar" alt="" class="avatar" />
            <div class="edit">
              <Icon type="ios-brush" />
              <p>修改头像</p>
              <input
                type="file"
                class="inputlogo"
                @change="chooseImage($event)"
                accept="image/png, image/jpeg,  image/jpg"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="title">姓名：</div>
        <div class="content">{{ current_user.name }}</div>
      </div>
      <div class="item">
        <div class="title">账号：</div>
        <div class="content">{{ current_user.tel }}</div>
      </div>
      <div class="item">
        <div class="title">角色：</div>
        <div class="content">{{ current_user.role_name }}</div>
      </div>
      <div class="item">
        <div class="title">账户密码：</div>
        <div class="content">
          <p class="text">******</p>
          <p class="btn" @click="changeSetPass">修改</p>
        </div>
      </div>
      <div class="item">
        <div class="title">微信绑定：</div>
        <div class="content">
          <p style="color: #888">
            {{ current_user.openid ? "已绑定" : "未绑定"
            }}<span style="font-size: 12px">（绑定后微信可直接扫码登录）</span>
          </p>
          <div class="btn">
            <p class="btn" @click="bindWechat" v-if="!current_user.openid">
              绑定
            </p>
            <p class="btn" v-else @click="delWechatBind">解除绑定</p>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="modelPass.status" mask scrollable title="修改密码">
      <div>
        <Form :model="modelPass.data" :label-width="120" class="form">
          <!-- <FormItem label="图形验证码" class="item">
            <Input
              v-model="modelPass.data.imageCode"
              placeholder="图形验证码"
              size="large"
              style="width: 150px"
            ></Input>
            <div
              class="imgCode"
              v-html="modelPass.imageCode"
              @click="getImageCode"
            ></div>
          </FormItem>
          <FormItem label="短信验证码" class="item">
            <Input
              v-model="modelPass.data.smsCode"
              placeholder="短信验证码"
              size="large"
              style="width: 150px"
            ></Input>
            <div class="smsBtn" @click="getCode">
              {{ modelPass.verifiyBtnText }}
            </div>
          </FormItem> -->
          <FormItem label="新管理密码" class="item" required>
            <Input
              v-model="modelPass.data.password"
              placeholder="请输入新管理密码"
              type="password"
              style="width: 260px;font-size:14px"
            ></Input>
            <div style="color: #aaa; font-size: 12px; height: 20px">
              新管理密码必须包含数字和字母，长度不低于6位
            </div>
          </FormItem>
          <FormItem
            label="确认管理密码"
            class="item"
            required
            style="padding-top: 30px;"
          >
            <Input
              v-model="modelPass.data.rpassword"
              placeholder="请再次输入新管理密码"
              type="password"
              style="width: 260px;font-size:14px"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" class="modelFooter" @click="save">完成</div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { uploadOSS } from "@/libs/util";
import config from "@/config";

export default {
  data() {
    return {
      modelPass: {
        status: false,
        data: {
          tel: "",
          imageCode: "",
          shop_id: 0,
          password: "",
          rpassword: "",
          smsCode: "",
        },
        imageCode: "",
        verifiyBtnText: "获取短信验证码",
        time: 0,
        timer: 0,
      },
    };
  },
  mounted() {
    this.GetUserInfo();
    if (this.$route.query.code) {
      this.GetWechatOpenid({ code: this.$route.query.code }).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg);
        if(res.status)this.GetUserInfo();
      });
    }
  },
  methods: {
    ...mapActions([
      "SaveStaffUserInfo",
      "GetUserInfo",
      "GetImageCode",
      "GetSmsCode",
      "SaveStaffPassword",
      "GetWechatOpenid",
    ]),
    chooseImage(e) {
      let file = e.target.files[0];
      if (file) {
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
          this.$Message.error("仅支持图片文件");
          return;
        }
        uploadOSS(`shop/avatar`, file).then((oss) => {
          if (oss.url) {
            this.SaveStaffUserInfo({
              id: this.current_user.user_id,
              avatar: oss.url,
            }).then((res) => {
              if (!res.status) {
                this.$Message.error(res.msg);
                return false;
              }
              this.GetUserInfo();
            });
          }
        });
      }
    },
    getImageCode() {
      this.GetImageCode({
        tel: this.current_user.tel,
        width: 130,
        height: 40,
      }).then((res) => {
        this.modelPass.imageCode = res;
      });
    },
    changeSetPass() {
      this.getImageCode();
      this.modelPass.status = true;
    },
    getCode() {
      if (!this.modelPass.data.imageCode) {
        this.$Message.error("请填写图形验证码");
        return false;
      }
      let data = {
        imageCode: this.modelPass.data.imageCode,
        tel: this.current_user.tel,
        shop_id: this.current_user.shop_id,
      };
      console.log(data);
      if (this.modelPass.time) return false;
      this.GetSmsCode(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (!res.status) {
          this.getImageCode();
          this.modelPass.imageCode = "";
          return false;
        }
        this.modelPass.time = 10;
        this.modelPass.timer = setInterval(() => {
          if (this.modelPass.time) {
            this.modelPass.time--;
            this.modelPass.verifiyBtnText = `${this.modelPass.time}秒后获取`;
          } else {
            this.modelPass.time = 0;
            this.modelPass.verifiyBtnText = `获取短信验证码`;
            clearInterval(this.modelPass.timer);
          }
        }, 1000);
      });
    },
    save() {
      console.log("current_user", this.current_user);
      /* if (!this.modelPass.data.smsCode) {
        this.$Message.error("请填写短信验证码");
        return false;
      } */
      let pwd = this.modelPass.data.password;
      let pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}');
      if (!pwdRegex.test(pwd)) {
        this.$Message.error("密码必须包含数字和字母，长度不低于6位");
        return false;
      }
      if (this.modelPass.data.rpassword != pwd) {
        this.$Message.error("确认管理密码与新管理密码不一致");
        return false;
      }
      let data = {
        shop_id: this.current_user.shop_id,
        tel: this.current_user.tel,
        // smsCode: this.modelPass.data.smsCode,
        password: this.modelPass.data.password,
      };
      console.log(data);
      this.SaveStaffPassword(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (res.status) {
          this.modelPass.data = {
            tel: "",
            imageCode: "",
            shop_id: 0,
            password: "",
            smsCode: "",
          };
          this.modelPass.status = false;
        }
      });
    },
    bindWechat() {
      const redirect_uri = encodeURIComponent(
        // `https://${location.host}/#/user_center`
        `http://${location.host}/#/user_center`
      );
      let url = `https://open.weixin.qq.com/connect/qrconnect?appid=${config.wechat.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`;
      window.location.href = url;
      console.log(url);
    },
    delWechatBind() {
      this.SaveStaffUserInfo({
        id: this.current_user.user_id,
        openid: "",
      }).then((res) => {
        if (!res.status) {
          this.$Message.error(res.msg);
          return false;
        }
        this.GetUserInfo();
      });
    },
  },
  computed: mapGetters({
    current_user: "current_user",
  }),
  watch: {},
};
</script>
<style lang='less' scoped>
.from {
  .item {
    display: flex;
    font-size: 16px;
    margin-top: 30px;
    margin-bottom: 0 !important;
    height: 14px;
    .content {
      display: flex;
      .btn {
        cursor: pointer;
        margin-left: 20px;
        color: #5cadff;
      }
      .avatarBox {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        position: relative;
        .avatar {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 0;
        }
        &:hover {
          .edit {
            display: flex;
            position: relative;
            .inputlogo {
              position: absolute;
              width: 100%;
              height: 100%;
              z-index: 10;
              cursor: pointer;
              opacity: 0;
            }
          }
        }
        .edit {
          display: none;
          background-color: rgba(0, 0, 0, 0.6);
          height: 60px;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 0;
          width: 60px;
          font-size: 12px;
          text-align: center;
          color: #fff;
          vertical-align: middle;
          // display: flex;
          align-items: center;
          /*实现水平居中*/
          justify-content: center;
          flex-direction: column;
        }
      }
    }
  }
}

.form {
  .item {
    margin-bottom: 10px !important;
    .imgCode {
      cursor: pointer;
      position: absolute;
      top: 0px;
      right: 80px;
    }
    .smsBtn {
      float: right;
      margin-right: 80px;
      cursor: pointer;
      background: #f8f8f8;
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 3px;
      border: 1px solid #a6a6a6;
    }
  }
}

.modelFooter {
  width: 50%;
  text-align: center;
  margin: 0 auto;
  line-height: 40px;
  background: #d40000;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  border-radius: 3px;
}
</style>
